<template>
  <flow-step-empty-base
    name="Cancellation Confirmation"
    :imgPath="img"
    description="Inform customers what they lose when they cancel."
    @cta-click="$emit('cta-click')"
  >
    <div>
      Remind customers of the investment they've made into your product and the value you can continue to provide. Maybe you could offer a glimpse
      into what they could expect in the future if they decide to stay.
    </div>
  </flow-step-empty-base>
</template>

<script>
import FlowStepEmptyBase from '@/components/FlowSteps/FlowStepEmptyBase.vue';
import img from '@/assets/img/icon-confirmation.svg';

export default {
  name: 'FlowStepCancelSurveyEmpty',
  components: {
    FlowStepEmptyBase,
  },
  data() {
    return {
      img,
    };
  },
};
</script>
